import {CDM_REQUEST, CDM_EMPLOYEES, CDM_CLEAR, CDM_FAIL} from '../store/config';

const cdmsInit = {
    isFetching: false,
    data: {},
    edit: {},
    permissions: [],
	error: undefined,
	timestamp: undefined
}

const cdms = (state=cdmsInit, action) => {
    switch (action.type) {
        case CDM_REQUEST:
            return {
                ...state,
                isFetching: action.isFetching,
                timestamp: action.timestamp
            }
        case CDM_EMPLOYEES:
            return {
                ...state,
                isFetching: action.isFetching,
                data: action.payload,
                permissions: action.permissions,
                timestamp: action.timestamp
            }
        case CDM_CLEAR:
            return {
                ...state,
                data: action.payload,
                edit: action.payload,
                permissions: action.permissions,
                timestamp: action.timestamp
            }
        case CDM_FAIL:
            return {
                ...state,
                isFetching: action.isFetching,
                error: action.error,
                timestamp: action.timestamp
            }
        default:
            return {
                ...state
            }
    }
}

export default cdms;



// WEBPACK FOOTER //
// ./src/reducers/cdms.js